type TRecruitmentProcessInterview = {
  interviewDate?: string | Date | null
}

type TRecruitmentProcessForDelete = {
  isActive?: boolean
  isDeleted?: boolean
  rounds?: Array<{ interviews?: TRecruitmentProcessInterview[] }>
}

export const getRecruitmentProcessInterviews = (
  process: TRecruitmentProcessForDelete | null | undefined,
): TRecruitmentProcessInterview[] => {
  if (!process?.rounds) return []
  return process.rounds.flatMap(round => round.interviews || [])
}

export const areRecruitmentProcessInterviewsClosed = (
  process: TRecruitmentProcessForDelete | null | undefined,
  now = new Date(),
): boolean => {
  const interviews = getRecruitmentProcessInterviews(process)
  if (interviews.length === 0) return true
  const nowTime = now.getTime()
  return interviews.every((interview) => {
    if (!interview?.interviewDate) return false
    const date = new Date(interview.interviewDate)
    return !Number.isNaN(date.getTime()) && date.getTime() < nowTime
  })
}

export const canDeleteRecruitmentProcess = (
  process: TRecruitmentProcessForDelete | null | undefined,
  now = new Date(),
): boolean => {
  if (!process || process.isDeleted) return false
  if (process.isActive !== false) return false
  return areRecruitmentProcessInterviewsClosed(process, now)
}

export const getRecruitmentProcessDeleteBlockReason = (
  process: TRecruitmentProcessForDelete | null | undefined,
  now = new Date(),
): 'active' | 'openInterviews' | null => {
  if (!process || process.isDeleted || process.isActive !== false) return 'active'
  if (!areRecruitmentProcessInterviewsClosed(process, now)) return 'openInterviews'
  return null
}
